export default __webpack_public_path__ + "24987afb4000a03a898bf568ca661d47.png";